"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SOCKET_SUBSCRIBE_STRATEGY = void 0;
const data_1 = require("../../enums/external/data");
const events_1 = require("../../enums/external/events");
const declarePayloadType = () => {
    return {};
};
exports.SOCKET_SUBSCRIBE_STRATEGY = {
    userStatusOnUserPage: {
        target: {
            place: data_1.SocketPlace.USER_PAGE,
            entity: data_1.SocketEntity.USER_STATUS,
            scope: data_1.SocketScope.ENTITY,
        },
        events: {
            [events_1.SocketEvent.EDIT]: declarePayloadType(),
        },
    },
};
